import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { ref, get } from 'firebase/database';

function Divisionwisefee() {
  const { className, division } = useParams();
  const navigate = useNavigate();
  const udiseNumber = localStorage.getItem('udiseNumber');

  const [feeData, setFeeData] = useState([]);
  const [academicYear, setAcademicYear] = useState('');
  const [studentFeeData, setStudentFeeData] = useState({});
  const [studentData, setStudentData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [activeFeeTypes, setActiveFeeTypes] = useState([]);
  const [additionalFees, setAdditionalFees] = useState([]);

  // Handle click on student count
 // Handle click on student count
const handleStudentCountClick = (feeItem) => {
  const isBusFee = feeItem.feeName.toLowerCase().trim() === 'bus fee';
  const isHostelFee = feeItem.feeName.toLowerCase().trim() === 'hostel fee';
  const isAdditionalFee = feeItem.isAdditional;

  navigate(`/stdfeenamelist/${className}/${division}`, {
    state: { 
      studentData, 
      academicYear, 
      feeType: feeItem.feeName,
      filterCriteria: {
        isBusFee,
        isHostelFee,
        isAdditionalFee,
        serialNo: feeItem.serialNo
      }
    },
  });
};

  // Fetch academic year
  useEffect(() => {
    if (!udiseNumber) return;

    const fetchDefaultYear = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['defaultSettings'], 'readonly');
        const objectStore = transaction.objectStore('defaultSettings');
        const request = objectStore.get('defaultSettings');

        request.onsuccess = (event) => {
          const defaultSetting = event.target.result;
          if (defaultSetting && defaultSetting.defaultYear) {
            setAcademicYear(defaultSetting.defaultYear);
            console.log("Default year from settings:", defaultSetting.defaultYear);
          } else {
            console.warn("No default year found in settings, fetching from Firebase.");
            const url = ref(db, `schoolRegister/${udiseNumber}/fees`);
            get(url)
              .then((snapshot) => {
                if (snapshot.exists()) {
                  const data = snapshot.val();
                  const years = Object.keys(data);
                  const latestYear = years.sort().reverse()[0];
                  setAcademicYear(latestYear);
                  console.log("Latest year from Firebase:", latestYear);
                }
              })
              .catch((err) => {
                console.error('Error fetching academic years from Firebase:', err);
              });
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching default settings:", event.target.error);
        };
      } catch (error) {
        console.error('Error accessing IndexedDB:', error);
      }
    };

    fetchDefaultYear();
  }, [udiseNumber]);

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };

  // Fetch studentData
  useEffect(() => {
    if (!udiseNumber) return;
    setIsLoading(true);
    const url = ref(db, `schoolRegister/${udiseNumber}/studentData`);
    get(url)
      .then((snapshot) => {
        if (snapshot.exists()) {
          setStudentData(snapshot.val());
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching student data:', err);
        setIsLoading(false);
      });
  }, [udiseNumber]);

  // Fetch fee data
  useEffect(() => {
    if (!academicYear || !udiseNumber) return;
    setIsLoading(true);
    const url = ref(db, `schoolRegister/${udiseNumber}/fees/${academicYear}`);
    get(url)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const feeArray = Object.entries(data).map(([feeType, details], index) => ({
            id: index + 1,
            feeName: feeType,
            classType: details?.classType || '',
            totalFee: parseFloat(details?.amount) || 0,
            receivedFee: 0,
            classSpecificReceived: {},
            classSpecificDiscount: {},
            classSpecificPending: {}
          }));
          setFeeData(feeArray);
        } else {
          setFeeData([]);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching fee data:', err);
        setIsLoading(false);
      });
  }, [academicYear, udiseNumber]);

  // Fetch studentFee data and determine active fee types
  useEffect(() => {
    if (!udiseNumber || !academicYear || !studentData || Object.keys(studentData).length === 0) return;

    setIsLoading(true);
    const url = ref(db, `schoolRegister/${udiseNumber}/studentFee`);
    get(url)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          if (data && data[academicYear] && typeof data[academicYear] === 'object') {
            setStudentFeeData(data[academicYear]);

            // Determine which fee types are active for this class and division
            const activeTypes = new Set();
            const additionalFeesList = [];
            
            // First check feeData for fees assigned to this class or 'all'
            feeData.forEach(feeItem => {
              if (feeItem.classType?.toLowerCase().trim() === className?.toLowerCase().trim() || 
                  feeItem.classType?.toLowerCase().trim() === 'all') {
                activeTypes.add(feeItem.feeName.toLowerCase().trim());
              }
            });

            // Then check student fee records for this class and division
            Object.entries(data[academicYear]).forEach(([serialNo, invoices]) => {
              const student = studentData[serialNo];
              if (
                student &&
                student.isActive !== false &&
                student.currentClass?.toLowerCase().trim() === className?.toLowerCase().trim() &&
                student.division?.toLowerCase().trim() === division?.toLowerCase().trim()
              ) {
                // Check for bus fee
                if (student.busFee === true) {
                  activeTypes.add('bus fee');
                }

                // Check for hostel fee
                if (student.hostel === true) {
                  activeTypes.add('hostel fee');
                }

                if (invoices && typeof invoices === 'object') {
                  const lastInvoiceNo =
                    invoices.lastInvoiceNo ||
                    Math.max(...Object.keys(invoices).filter((k) => k !== 'lastInvoiceNo').map(Number));
                  if (lastInvoiceNo && invoices[lastInvoiceNo]) {
                    Object.keys(invoices[lastInvoiceNo]).forEach(feeType => {
                      const normalizedFeeType = feeType.toLowerCase().trim();
                      activeTypes.add(normalizedFeeType);

                      // Check for pending and identity fees
                      if (normalizedFeeType.includes('pending')) {
                        activeTypes.add('pending fee');
                        const feeDetails = invoices[lastInvoiceNo][feeType];
                        additionalFeesList.push({
                          id: `pending`,
                          feeName: `Pending Fee`,
                          classType: className,
                          totalFee: parseFloat(feeDetails?.amount || 0),
                          receivedFee: parseFloat(feeDetails?.beforePay || 0),
                          discount: parseFloat(feeDetails?.discountAmount || 0),
                          serialNo
                        });
                      }

                      if (normalizedFeeType.includes('identity') || normalizedFeeType.includes('id')) {
                        activeTypes.add('identity card fee');
                        const feeDetails = invoices[lastInvoiceNo][feeType];
                        additionalFeesList.push({
                          id: `id-${serialNo}`,
                          feeName: `Identity Card Fee`,
                          classType: className,
                          totalFee: parseFloat(feeDetails?.amount || 0),
                          receivedFee: parseFloat(feeDetails?.beforePay || 0),
                          discount: parseFloat(feeDetails?.discountAmount || 0),
                          serialNo
                        });
                      }
                    });
                  }
                }
              }
            });

            setActiveFeeTypes(Array.from(activeTypes));
            setAdditionalFees(additionalFeesList);
            
            // Update fee data with received amounts
            setFeeData((prevFeeData) =>
              prevFeeData.map((feeItem) => {
                let totalReceived = 0;
                const classSpecificReceived = {};
                const classSpecificDiscount = {};
                const classSpecificPending = {};
                
                Object.entries(data[academicYear]).forEach(([serialNo, invoices]) => {
                  const student = studentData[serialNo];
                  if (
                    !student ||
                    student.isActive === false ||
                    student.currentClass?.toLowerCase().trim() !== className?.toLowerCase().trim() ||
                    student.division?.toLowerCase().trim() !== division?.toLowerCase().trim()
                  ) return;

                  if (invoices && typeof invoices === 'object') {
                    const lastInvoiceNo =
                      invoices.lastInvoiceNo ||
                      Math.max(...Object.keys(invoices).filter((k) => k !== 'lastInvoiceNo').map(Number));
                    if (lastInvoiceNo && invoices[lastInvoiceNo]) {
                      Object.entries(invoices[lastInvoiceNo]).forEach(([feeType, details]) => {
                        if (
                          details &&
                          feeType.toLowerCase().trim() === feeItem.feeName.toLowerCase().trim() &&
                          (details.class?.toLowerCase().trim() === feeItem.classType?.toLowerCase().trim() ||
                            feeItem.classType?.toLowerCase().trim() === 'all')
                        ) {
                          const amount = parseFloat(details.beforePay || 0);
                          const discount = parseFloat(details.discountAmount || 0);
                          totalReceived += amount;
                          if (details.class) {
                            const classNameLower = details.class.toLowerCase().trim();
                            classSpecificReceived[classNameLower] =
                              (classSpecificReceived[classNameLower] || 0) + amount;
                            classSpecificDiscount[classNameLower] =
                              (classSpecificDiscount[classNameLower] || 0) + discount;
                            const studentCount = getStudentCountForClassAndDivision();
                            const finalAmount =
                              (feeItem.totalFee * studentCount) - (classSpecificDiscount[classNameLower] || 0);
                            classSpecificPending[classNameLower] =
                              finalAmount - (classSpecificReceived[classNameLower] || 0);
                          }
                        }
                      });
                    }
                  }
                });

                return {
                  ...feeItem,
                  receivedFee: totalReceived,
                  classSpecificReceived,
                  classSpecificDiscount,
                  classSpecificPending
                };
              })
            );
          } else {
            setStudentFeeData({});
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching student fee data:', err);
        setIsLoading(false);
      });
  }, [udiseNumber, academicYear, studentData, className, division, feeData]);

  // Function to count active students for a specific class and division
  const getStudentCountForClassAndDivision = () => {
    if (!studentData || typeof studentData !== 'object') return 0;
    return Object.values(studentData).filter(
      (student) =>
        student?.currentClass?.toLowerCase().trim() === className?.toLowerCase().trim() &&
        student?.division?.toLowerCase().trim() === division?.toLowerCase().trim() &&
        student?.isActive !== false
    ).length;
  };

  // Get bus fee amount
  const getBusFeeAmount = () => {
    if (!feeData || feeData.length === 0) return 0;
    const busFee = feeData.find(fee => fee.feeName.toLowerCase().trim() === 'bus fee');
    return busFee ? busFee.totalFee : 0;
  };

  // Get hostel fee amount
  const getHostelFeeAmount = () => {
    if (!feeData || feeData.length === 0) return 0;
    const hostelFee = feeData.find(fee => fee.feeName.toLowerCase().trim() === 'hostel fee');
    return hostelFee ? hostelFee.totalFee : 0;
  };

  // Count students with bus fee
  const getBusFeeStudentCount = () => {
    if (!studentData || typeof studentData !== 'object') return 0;
    return Object.values(studentData).filter(
      (student) =>
        student?.currentClass?.toLowerCase().trim() === className?.toLowerCase().trim() &&
        student?.division?.toLowerCase().trim() === division?.toLowerCase().trim() &&
        student?.isActive !== false &&
        student?.busFee === true
    ).length;
  };

  // Count students with hostel fee
  const getHostelFeeStudentCount = () => {
    if (!studentData || typeof studentData !== 'object') return 0;
    return Object.values(studentData).filter(
      (student) =>
        student?.currentClass?.toLowerCase().trim() === className?.toLowerCase().trim() &&
        student?.division?.toLowerCase().trim() === division?.toLowerCase().trim() &&
        student?.isActive !== false &&
        student?.hostel === true
    ).length;
  };

  // Filter fees for the specific class (or 'all') and only those that are active
  const feesForClass = feeData.filter(
    (feeItem) =>
      (feeItem.classType?.toLowerCase().trim() === className?.toLowerCase().trim() ||
        feeItem.classType?.toLowerCase().trim() === 'all') &&
      activeFeeTypes.includes(feeItem.feeName.toLowerCase().trim())
  );

  // Combine regular fees with additional fees
  const allFees = [
    ...feesForClass.map(fee => ({
      ...fee,
      isAdditional: false,
      discount: fee.classSpecificDiscount[className.toLowerCase().trim()] || 0
    })),
    ...additionalFees.map(fee => ({
      ...fee,
      isAdditional: true
    }))
  ];

  // Add bus fee if active
  if (activeFeeTypes.includes('bus fee')) {
    const busFeeAmount = getBusFeeAmount() * getBusFeeStudentCount();
    let busFeeReceived = 0;
    let busFeeDiscount = 0;

    Object.entries(studentFeeData).forEach(([serialNo, invoices]) => {
      const student = studentData[serialNo];
      if (
        student &&
        student.isActive !== false &&
        student.currentClass?.toLowerCase().trim() === className?.toLowerCase().trim() &&
        student.division?.toLowerCase().trim() === division?.toLowerCase().trim() &&
        student.busFee === true
      ) {
        if (invoices && typeof invoices === 'object') {
          const lastInvoiceNo =
            invoices.lastInvoiceNo ||
            Math.max(...Object.keys(invoices).filter((k) => k !== 'lastInvoiceNo').map(Number));
          if (lastInvoiceNo && invoices[lastInvoiceNo]) {
            Object.entries(invoices[lastInvoiceNo]).forEach(([feeType, details]) => {
              if (feeType.toLowerCase().includes('bus')) {
                busFeeReceived += parseFloat(details?.beforePay || 0);
                busFeeDiscount += parseFloat(details?.discountAmount || 0);
              }
            });
          }
        }
      }
    });

    allFees.push({
      id: 'bus-fee',
      feeName: 'Bus Fee',
      classType: className,
      totalFee: busFeeAmount,
      receivedFee: busFeeReceived,
      discount: busFeeDiscount,
      isAdditional: true
    });
  }

  // Add hostel fee if active
  if (activeFeeTypes.includes('hostel fee')) {
    const hostelFeeAmount = getHostelFeeAmount() * getHostelFeeStudentCount();
    let hostelFeeReceived = 0;
    let hostelFeeDiscount = 0;

    Object.entries(studentFeeData).forEach(([serialNo, invoices]) => {
      const student = studentData[serialNo];
      if (
        student &&
        student.isActive !== false &&
        student.currentClass?.toLowerCase().trim() === className?.toLowerCase().trim() &&
        student.division?.toLowerCase().trim() === division?.toLowerCase().trim() &&
        student.hostel === true
      ) {
        if (invoices && typeof invoices === 'object') {
          const lastInvoiceNo =
            invoices.lastInvoiceNo ||
            Math.max(...Object.keys(invoices).filter((k) => k !== 'lastInvoiceNo').map(Number));
          if (lastInvoiceNo && invoices[lastInvoiceNo]) {
            Object.entries(invoices[lastInvoiceNo]).forEach(([feeType, details]) => {
              if (feeType.toLowerCase().includes('hostel')) {
                hostelFeeReceived += parseFloat(details?.beforePay || 0);
                hostelFeeDiscount += parseFloat(details?.discountAmount || 0);
              }
            });
          }
        }
      }
    });

    allFees.push({
      id: 'hostel-fee',
      feeName: 'Hostel Fee',
      classType: className,
      totalFee: hostelFeeAmount,
      receivedFee: hostelFeeReceived,
      discount: hostelFeeDiscount,
      isAdditional: true
    });
  }

  const handleClose = () => {
    navigate(-1);
  };

  // Helper function to safely format numbers
  const formatNumber = (num) => {
    if (num === undefined || num === null || isNaN(num)) return '0.00';
    return parseFloat(num).toFixed(2);
  };

  return (
    <div className='main-content-of-page'>
      <div
        style={{
          padding: '24px',
          maxWidth: '1280px',
          margin: '0 auto',
          background: 'linear-gradient(to bottom right, rgba(0, 123, 255, 0.3), rgba(255, 255, 255, 1))',
          minHeight: '100vh',
          fontFamily: "'Inter', sans-serif",
        }}
      >
        <button 
          style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '20px', float: 'right', marginBottom: '10px' }} 
          onClick={handleClose}
        >
          X
        </button>
        <h1
          style={{
            fontSize: '22px',
            fontWeight: '700',
            color: '#1a202c',
            marginBottom: '24px',
            borderBottom: '2px solid #e2e8f0',
            paddingBottom: '8px',
            textAlign:'center',
            fontWeight:'bold'
          }}
        >
          Fee Details for {className} - Division {division}
        </h1>

        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
          }}
        >
          <div style={{ overflowX: 'auto' }}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '14px',
              }}
            >
              <thead
                style={{
                  backgroundColor: '#edf2f7',
                  textTransform: 'uppercase',
                  color: '#4a5568',
                }}
              >
                <tr>
                  <th
                    style={{
                      padding: '16px',
                      textAlign: 'left',
                      fontWeight: '600',
                      borderBottom: '1px solid #e2e8f0',
                      backgroundColor:'#004d99',
                      color:'white'
                    }}
                  >
                    No. of Students
                  </th>
                  <th
                    style={{
                      padding: '16px',
                      textAlign: 'left',
                      fontWeight: '600',
                      borderBottom: '1px solid #e2e8f0',
                      backgroundColor:'#004d99',
                      color:'white'
                    }}
                  >
                    Fee Type
                  </th>
                  <th
                    style={{
                      padding: '16px',
                      textAlign: 'left',
                      fontWeight: '600',
                      borderBottom: '1px solid #e2e8f0',
                      backgroundColor:'#004d99',
                      color:'white'
                    }}
                  >
                    Total Fee
                  </th>
                  <th
                    style={{
                      padding: '16px',
                      textAlign: 'left',
                      fontWeight: '600',
                      borderBottom: '1px solid #e2e8f0',
                      backgroundColor:'#004d99',
                      color:'white'
                    }}
                  >
                    Discount Fee
                  </th>
                  <th
                    style={{
                      padding: '16px',
                      textAlign: 'left',
                      fontWeight: '600',
                      borderBottom: '1px solid #e2e8f0',
                      backgroundColor:'#004d99',
                      color:'white'
                    }}
                  >
                    Final Amount
                  </th>
                  <th
                    style={{
                      padding: '16px',
                      textAlign: 'left',
                      fontWeight: '600',
                      borderBottom: '1px solid #e2e8f0',
                      backgroundColor:'#004d99',
                      color:'white'
                    }}
                  >
                    Received Fee
                  </th>
                  <th
                    style={{
                      padding: '16px',
                      textAlign: 'left',
                      fontWeight: '600',
                      borderBottom: '1px solid #e2e8f0',
                      backgroundColor:'#004d99',
                      color:'white'
                    }}
                  >
                    Pending Fee
                  </th>
                </tr>
              </thead>
              <tbody>
                {allFees.length > 0 ? (
                  allFees.map((feeItem, index) => {
                    const total = feeItem.totalFee || 0;
                    const discount = feeItem.discount || 0;
                    const received = feeItem.receivedFee || 0;
                    const pending = total - discount - received;

                    return (
                      <tr
                        key={feeItem.id}
                        style={{
                          backgroundColor: index % 2 === 0 ? '#ffffff' : '#f7fafc',
                          transition: 'background-color 0.2s',
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = '#edf2f7')
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            index % 2 === 0 ? '#ffffff' : '#f7fafc')
                        }
                      >
                       <td
  style={{
    padding: '16px',
    color: '#2d3748',
    borderBottom: '1px solid #edf2f7',
    cursor: 'pointer',
    textDecoration: 'underline',
  }}
  onClick={() => handleStudentCountClick(feeItem)}
>
  {feeItem.id === 'bus-fee' ? getBusFeeStudentCount() : 
   feeItem.id === 'hostel-fee' ? getHostelFeeStudentCount() : 
   feeItem.serialNo ? 1 : getStudentCountForClassAndDivision()}
</td>
                        <td
                          style={{
                            padding: '16px',
                            color: '#2d3748',
                            borderBottom: '1px solid #edf2f7',
                          }}
                        >
                          {feeItem.feeName}
                        </td>
                        <td
                          style={{
                            padding: '16px',
                            color: '#2d3748',
                            borderBottom: '1px solid #edf2f7',
                          }}
                        >
                          {formatNumber(total)}
                        </td>
                        <td
                          style={{
                            padding: '16px',
                            color: '#2d3748',
                            borderBottom: '1px solid #edf2f7',
                          }}
                        >
                          {formatNumber(discount)}
                        </td>
                        <td
                          style={{
                            padding: '16px',
                            color: '#2d3748',
                            borderBottom: '1px solid #edf2f7',
                          }}
                        >
                          {formatNumber(total - discount)}
                        </td>
                        <td
                          style={{
                            padding: '16px',
                            color: '#2d3748',
                            borderBottom: '1px solid #edf2f7',
                          }}
                        >
                          {formatNumber(received)}
                        </td>
                        <td
                          style={{
                            padding: '16px',
                            color: pending > 0 ? '#e53e3e' : '#2d3748',
                            borderBottom: '1px solid #edf2f7',
                            fontWeight: pending > 0 ? '600' : '400',
                          }}
                        >
                          {formatNumber(pending)}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={7}
                      style={{
                        padding: '16px',
                        textAlign: 'center',
                        color: '#2d3748',
                        borderBottom: '1px solid #edf2f7',
                      }}
                    >
                      <div style={{
                        padding: '40px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: '#64748b'
                      }}>
                        {isLoading ? (
                          <>
                            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px', animation: 'spin 1s linear infinite' }}>
                              <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/>
                              <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" fill="#3b82f6"/>
                            </svg>
                            Loading fee details...
                          </>
                        ) : (
                          'No fee data available for this class and division'
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Divisionwisefee;